import React, { useState, useEffect } from "react";
import Logob01 from '../../assets/images/logo-main.png';
import Logo02 from '../../assets/images/logo2.png';
import { Link } from "react-router-dom";


const Headertwo = () => {

    const [isFixed, setIsFixed] = useState(false);
    const [isSearchActive, setSearchActive] = useState(false);
    const [isMenuExpanded, setMenuExpanded] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const handleScroll = () => {
        setIsFixed(window.scrollY > 50);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const handleSearchClick = () => {
        setSearchActive(true);
        document.body.classList.add("search-active");
    };

    const handleCloseSearch = () => {
        setSearchActive(false);
        document.body.classList.remove("search-active");
    };
    const toggleMenu = () => {
        setMenuExpanded(prevState => !prevState);

    };
    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    return (
        <>
            {/* <div className="topbar-three">
                <div className="container">
                    <div className="row">
                        <div className="col-8">
                            <p>Welcome to Loan lift Your Trusted Financial partner</p>
                        </div>
                        <div className="col-4">
                            <ul className="topbar-three-social-media">
                                <li>
                                    <Link to="https://www.facebook.com/">
                                        <i className="fa-brands fa-facebook-f" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/">
                                        <i className="fa-brands fa-twitter" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.instagram.com/">
                                        <i className="fa-brands fa-instagram" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://in.linkedin.com/">
                                        <i className="fa-brands fa-linkedin-in" />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> */}
            <header className={isFixed ? "main-header main-header-four " : "main-header main-header-four"}>
                <div className="container">
                    <nav className="main-menu">
                        <div className="main-menu-logo">
                            <Link to="/">
                                <img src={Logob01} alt="header-logo" />
                            </Link>
                        </div>
                        <div className="main-menu-inner">
                            <ul className="main-menu-list">
                                <li className="menu-item-children">
                                    <Link to="/">Home</Link>
                                    {/* <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/">Home One</Link>
                                        </li>
                                        <li>
                                            <Link to="/Hometwo">Home Two</Link>
                                        </li>
                                        <li>
                                            <Link to="/Homethree">Home Three</Link>
                                        </li>
                                    </ul> */}
                                </li>
                                <li className="menu-item-children">
                                    <Link to="/about-us">About</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/core-values">Core Values</Link>
                                        </li>
                                        <li>
                                            <Link to="/our-team">Our Team</Link>
                                        </li>
                                        {/* <li>
                                            <Link to="/founders-message">Founder's Message</Link>
                                        </li>
                                        <li>
                                            <Link to="/india-team">India Team</Link>
                                        </li>
                                        <li>
                                            <Link to="/us-team">U.S. Team</Link>
                                        </li>
                                        <li>
                                            <Link to="/canada-team">Canada Team</Link>
                                        </li> */}
                                        {/* <li>
                                            <Link to="/Team">Meet The Team</Link>
                                        </li>
                                        <li>
                                            <Link to="/Teamdetails">Team Details</Link>
                                        </li> */}
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="/Services">Services</Link>
                                    <i className="fa-solid fa-chevron-down" />

                                    <ul className="row w-full" style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(4, 1fr)",
                                        gap: "20px",
                                        marginTop: "10px",
                                        backgroundColor: "#fff",
                                        position: "absolute",
                                        left: "-250px",
                                        top: "100%",
                                        minWidth: "1000px",
                                        padding: "30px",
                                        boxShadow: "0 0 60px 0 rgb(53 57 69 / 15%)",
                                        borderBottom: "2px solid var(--loanlift-primary-bg)",
                                        zIndex: 999,
                                        opacity: 0,
                                        visibility: "hidden",
                                        transformOrigin: "top center",
                                        transform: "scaleY(0) translateZ(100px)",
                                        transition: "opacity 500ms ease, visibility 500ms ease, transform 700ms ease",
                                        listStyle: "none",
                                        margin: 0
                                    }}>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/execution-of-wills" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Execution of Wills</Link></li>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/real-estate-management" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Real Estate Management</Link></li>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/documentation" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Documentation</Link></li>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/legal" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Legal</Link></li>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/tours-travel" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Tours & Travel</Link></li>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/taxation" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Taxation</Link></li>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/finance-and-accountancy" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Finance and Accountancy</Link></li>
                                        {/* <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/immigration" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Immigration</Link></li> */}
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/events-and-entertainment" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Events & Entertainment</Link></li>
                                        <li className="co" style={{ listStyle: "none", padding: 0, margin: 0 }}><Link to="/security" style={{ display: "block", padding: "12px 15px", color: "#333", textDecoration: "none", borderRadius: "4px", transition: "all 0.3s ease", borderLeft: "3px solid transparent" }}>Security</Link></li>
                                    </ul>

                                </li>
                                <li className="menu-item-children" style={{ position: "relative", padding: "0", margin: "0", fontSize: "1rem", width: "150px" }}>
                                    <Link to="/why-choose-us">Why Choose Us</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/the-advisors-way">The Advisors Way</Link>
                                        </li>
                                        <li>
                                            <Link to="/brand-vision">Brand Vision</Link>
                                        </li>
                                        <li>
                                            <Link to="/testimonials">Testimonials</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="/resources">Resources</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/guides">Guides</Link>
                                        </li>
                                        <li>
                                            <Link to="/newsletter">Newsletter</Link>
                                        </li>
                                        {/*  <li>
                                            <Link to="/">Blog Grid 2</Link>
                                        </li>
                                        <li>
                                            <Link to="/">Blog Details</Link>
                                        </li>*/}
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="/blog">Blog</Link>
                                </li>
                            </ul>
                            <div className="header-right-end" onClick={toggleMenu}>
                                <span className="line-1" />
                                <span className="line-2" />
                                <span className="line-3" />
                            </div>
                        </div>
                        <div className={`main-menu-right ${isSearchActive ? "active" : ""}`}>
                            {/* <Link to="#" className="search-btn" onClick={handleSearchClick}>
                                <i className="flaticon-search-interface-symbol" />
                            </Link> */}
                            <div className="fade-in-up">
                                <Link to="/contact-us" className="btn btn-primary bg-black">
                                    Free Consulation
                                    <i className="flaticon-next" />
                                </Link>
                            </div>
                        </div>
                    </nav>
                </div>
                <div className={`mobile-nav-wrapper ${isMenuExpanded ? "expanded" : ""}`}>
                    <div className="mobile-nav-overlay mobile-nav-toggler" onClick={toggleMenu} />
                    <div className="mobile-nav-content">
                        <Link to="#" className="mobile-nav-close mobile-nav-toggler" onClick={toggleMenu}>
                            <span />
                            <span />
                        </Link>
                        <div className="logo-box">
                            <Link to="/">
                                <img width={150} src={Logo02} alt="logo" />
                            </Link>
                        </div>
                        <div className="mobile-nav-container">
                            <ul className="mobile-menu-list">
                                <li className={`menu-item-has-children ${openDropdown === 1 ? "dropdown-open" : ""}`}>
                                    <Link to="/" className="expended" onClick={() => toggleDropdown(1)}>Home
                                        {/* <button
                                            aria-label="dropdown toggler"
                                            className={`dropdown-btn ${openDropdown === 1 ? "expanded" : ""}`}
                                            onClick={() => setOpenDropdown(!openDropdown)}
                                        >
                                            <i className="flaticon-right-arrow" />
                                        </button> */}
                                    </Link>
                                    {/* {openDropdown === 1 && (
                                        <ul>
                                            <li>
                                                <Link to="/">Home-1</Link>
                                            </li>
                                            <li>
                                                <Link to="/Hometwo">Home-2</Link>
                                            </li>
                                            <li>
                                                <Link to="/Homethree">Home-3</Link>
                                            </li>
                                        </ul>
                                    )} */}
                                </li>
                                <li className={`menu-item-has-children ${openDropdown === 2 ? "dropdown-open" : ""}`}>
                                    <Link to="/about-us" className="expanded" onClick={() => toggleDropdown(2)}>About
                                        <button
                                            aria-label="dropdown toggler"
                                            className={`dropdown-btn ${openDropdown === 2 ? "expanded" : ""}`}
                                            onClick={() => setOpenDropdown(!openDropdown)}
                                        >
                                            <i className="flaticon-right-arrow" />
                                        </button>
                                    </Link>
                                    {openDropdown === 2 && (
                                        <ul>
                                            <li>
                                                <Link to="/core-values">Core Values </Link>
                                            </li>
                                            <li>
                                                <Link to="/our-team">Our Team </Link>
                                            </li>
                                            {/* <li>
                                                <Link to="/founders-message">Founder's Message</Link>
                                            </li>
                                            <li>
                                                <Link to="/india-team">India Team</Link>
                                            </li>
                                            <li>
                                                <Link to="/us-team">U.S. Team</Link>
                                            </li>
                                            <li><Link to="/canada-team">Canada Team</Link></li> */}
                                        </ul>
                                    )}
                                </li>
                                <li className={`menu-item-has-children ${openDropdown === 3 ? "dropdown-open" : ""}`}>
                                    <Link to="/Services" className="expanded" onClick={() => toggleDropdown(3)}>Services
                                        <button
                                            aria-label="dropdown toggler"
                                            className={`dropdown-btn ${openDropdown === 3 ? "expanded" : ""}`}
                                            onClick={() => setOpenDropdown(!openDropdown)}
                                        >
                                            <i className="flaticon-right-arrow" />
                                        </button>
                                    </Link>
                                    {openDropdown === 3 && (
                                        <ul>
                                            <li>
                                                <Link to="/execution-of-wills">Execution of Wills</Link>
                                            </li>
                                            <li>
                                                <Link to="/real-estate-management">Real Estate Management </Link>
                                            </li>
                                            <li>
                                                <Link to="/documentation">Documentation</Link>
                                            </li>
                                            <li><Link to="/legal">Legal</Link> </li>
                                            <li>
                                                <Link to="/tours-travel">Tours & Travel</Link>
                                            </li>
                                            <li>
                                                <Link to="/taxation">Taxation</Link>
                                            </li>
                                            {/* <li>
                                                <Link to="/medical-services">Medical Services</Link>
                                            </li> */}
                                            <li><Link to="/finance-and-accountancy">Finance & Accountancy</Link></li>
                                            {/* <li><Link to="/immigration">Immigration</Link></li> */}
                                            <li><Link to="/events-and-entertainment">Events & Entertainment</Link></li>
                                            <li><Link to="/security">Security</Link></li>
                                        </ul>
                                    )}
                                </li>
                                <li className={`menu-item-has-children ${openDropdown === 4 ? "dropdown-open" : ""}`}>
                                    <Link to="/why-choose-us" className="expanded" onClick={() => toggleDropdown(4)}>Why Choose Us
                                        <button
                                            aria-label="dropdown toggler"
                                            className={`dropdown-btn ${openDropdown === 4 ? "expanded" : ""}`}
                                            onClick={() => setOpenDropdown(!openDropdown)}
                                        >
                                            <i className="flaticon-right-arrow" />
                                        </button>
                                    </Link>
                                    {openDropdown === 4 && (
                                        <ul>
                                            <li>
                                                <Link to="/the-advisors-way">The Advisors Way</Link>
                                            </li>
                                            <li>
                                                <Link to="/brand-vision">Brand Vision</Link>
                                            </li>
                                            <li>
                                                <Link to="/testimonials">Testimonials</Link>
                                            </li>
                                            {/* <li>
                                                <Link to="/Blogdetails">Blog Details</Link>
                                            </li> */}
                                        </ul>
                                    )}
                                </li>
                                <li className={`menu-item-has-children ${openDropdown === 5 ? "dropdown-open" : ""}`}>
                                    <Link to="/resources" className="expanded" onClick={() => toggleDropdown(5)}>Resources
                                        <button
                                            aria-label="dropdown toggler"
                                            className={`dropdown-btn ${openDropdown === 5 ? "expanded" : ""}`}
                                            onClick={() => setOpenDropdown(!openDropdown)}
                                        >
                                            <i className="flaticon-right-arrow" />
                                        </button>
                                    </Link>
                                    {openDropdown === 5 && (
                                        <ul>
                                            <li>
                                                <Link to="/guides">Guides</Link>
                                            </li>
                                            <li>
                                                <Link to="/newsletter">Newsletter</Link>
                                            </li>
                                            {/* <li>
                                                <Link to="/Portfoliodetails">Portfolio Details</Link>
                                            </li> */}
                                        </ul>
                                    )}
                                </li>
                                <li className={`menu-item-has-children ${openDropdown === 4 ? "dropdown-open" : ""}`}>
                                    <Link to="/blog" className="expanded" onClick={() => toggleDropdown(4)}>Blog
                                        {/* <button
                                            aria-label="dropdown toggler"
                                            className={`dropdown-btn ${openDropdown === 4 ? "expanded" : ""}`}
                                            onClick={() => setOpenDropdown(!openDropdown)}
                                        >
                                            <i className="flaticon-right-arrow" />
                                        </button> */}
                                    </Link>
                                    {/* {openDropdown === 4 && (
                                        <ul>
                                            <li>
                                                <Link to="/Portfoliogrid">The Advisors Way</Link>
                                            </li>
                                            <li>
                                                <Link to="/Bloggrid">Brand Vision</Link>
                                            </li>
                                            <li>
                                                <Link to="/Portfoliodetails">Testimonials</Link>
                                            </li>
                                            <li>
                                                <Link to="/Blogdetails">Blog Details</Link>
                                            </li>
                                        </ul>
                                    )} */}
                                </li>
                            </ul>
                            <Link to="/contact-us">  <button className="btn btn-primary  my-4">Free Consulation           <i className="flaticon-next" /></button>
                            </Link>
                        </div>
                    </div>
                </div>
            </header>
            {isSearchActive && (
                <div className={`search-popup ${isSearchActive ? "active" : ""}`}>
                    <button className="close-search " onClick={handleCloseSearch} />
                    <form method="post" action="/Blog">
                        <div className="form-group">
                            <input
                                type="search"
                                name="search"
                                placeholder="Search Here"
                                required=""
                            />
                            <button type="submit">
                                <i className="flaticon-search" />
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </>
    )
}
export default Headertwo;